import { useState, useEffect, useCallback } from "react";
import { ICompetitionStandings } from "@grassrootly/api";
import { GetCompetitionStandings } from "@grassrootly/api/providers/supabase-provider/actions";

export const useCompetitionStandings = (competitionId: number, seasonId: number) => {
  const [standings, setStandings] = useState<ICompetitionStandings[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchStandings = useCallback(async () => {
    if (!seasonId) return;
    
    setLoading(true);
    try {
      const data = await GetCompetitionStandings({ seasonId });
      setStandings(data);
    } catch (error) {
      console.error("Error fetching competition standings:", error);
      setStandings([]);
    } finally {
      setLoading(false);
    }
  }, [seasonId]);

  useEffect(() => {
    fetchStandings();
  }, [fetchStandings]);

  const refreshStandings = useCallback(() => {
    fetchStandings();
  }, [fetchStandings]);

  return {
    standings,
    loading,
    refreshStandings,
  };
};
